import add from '@/pages/customer/add'
import listCustomer from "@/pages/customer/listCustomer";
import edit from "@/pages/customer/edit";
import changePass from "@/pages/customer/changePass";
import profile from "@/pages/customer/profile";
import customersMap from "../pages/customer/customersMap";
import CustomerInfoForm from "@/pages/CustomerInfoForm.vue";

const routes = [
  {
    path:'/Customer/Add',
    component:add,
    meta:{requiredAuth:true}
  },
  {
    path: "/Customer/List",
    component: listCustomer,
    meta: {requiredAuth: true},
  },
  {
    path: "/Customer/Edit/:id",
    component: edit,
    meta: {requiredAuth: true},
  },
  {
    path: "/changePassword",
    component: changePass,
    meta: {requiredAuth: true},
  },
  {
    path: "/profile",
    component: profile,
    meta: {requiredAuth: true},
  },
  {
    path: "/CustomerMap",
    component: customersMap,
    meta: {requiredAuth: true},
  },
  {
    path: "/CustomerInfoForm/:id",
    component: CustomerInfoForm,
    meta: {requiredAuth: true},
  }
]

export default routes;